import { Model } from '@vuex-orm/core';
import User from '@/models/core/User';
import Membership from '@/models/core/Membership';

export default class Context extends Model {
  static entity = 'context';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.string(''),
      host: this.string(''),
      domain: this.string(''),
      composerTemplate: this.string(''),
      user_id: this.string(''),
      user: this.belongsTo(User, 'user_id')
    };
  }

  get membership() {
    return Membership.query()
      .with('team')
      .where(member => {
        return member.user_id === this.user_id;
      })
      .whereHas('team', query => {
        query.where(team => {
          return team.domain === this.domain;
        });
      })
      .first();
  }

  get isLoaded() {
    return this.user_id.length > 0 && this.membership !== null;
  }
}
